import api from './api';

export const locationService = {
  getAll: async () => {
    const response = await api.get('/locations');
    return response.data.locations;
  },

  getActive: async () => {
    const response = await api.get('/locations/active');
    return response.data.locations;
  },

  getById: async (id) => {
    const response = await api.get(`/locations/${id}`);
    return response.data.location;
  },

  create: async (locationData) => {
    const response = await api.post('/locations', locationData);
    return response.data.location;
  },

  update: async (id, locationData) => {
    const response = await api.put(`/locations/${id}`, locationData);
    return response.data.location;
  },

  delete: async (id) => {
    const response = await api.delete(`/locations/${id}`);
    return response.data;
  },

  batchUpload: async (locations) => {
    const response = await api.post('/locations/bulk', { locations });
    return response.data;
  },
};
